import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=31444350&scoped=true&"
import script from "./Group.vue?vue&type=script&lang=js&"
export * from "./Group.vue?vue&type=script&lang=js&"
import style0 from "./Group.vue?vue&type=style&index=0&id=31444350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31444350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31444350')) {
      api.createRecord('31444350', component.options)
    } else {
      api.reload('31444350', component.options)
    }
    module.hot.accept("./Group.vue?vue&type=template&id=31444350&scoped=true&", function () {
      api.rerender('31444350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/SettingRenew/Contents/Group.vue"
export default component.exports